export const state = {
    columns: [],
};
